import React from 'react'
import SuperAgent from 'superagent'

import { domainSettings, settings } from '../../../../config/generatedConfig'
import ReduxStores from '../../../stores/connects'

import Helpers from '../../../../_plugins/lib/helpers'
import dateHelper from '../../../../_plugins/lib/dateHelper'

import defaultAuthenticationConfig from '../../../../shared/config/authentication/de'
import getVoucherConfig from '../../../../shared/config/getVoucher'
import RefundModal from '../_includes/vouchers/RefundModal'

const voucherLanguage = ['de', 'en'].indexOf(domainSettings.language.toLowerCase()) >= 0 ? domainSettings.language.toLowerCase() : 'de'
const voucherTranslations = require(`../../../config/components/vouchers/${voucherLanguage}/`)

class Vouchers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isFetchingVoucher: false,
      hasFetchedVoucher: false,
      lookUpError: false,
      lookUpErrorMessage: null,
      voucherDetails: null,
      modalVisibility: false,
      modalVoucher: null,
      refundError: false,
      refundSuccess: false,
      emailAddress: ''
    }

    this.voucherRef = React.createRef()

    this.getVouchers = this.getVouchers.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.lookUpVoucher = this.lookUpVoucher.bind(this)
    this.voucherLookupResponse = this.voucherLookupResponse.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.handleRefundRequest = this.handleRefundRequest.bind(this)
    this.refundRequestResponse = this.refundRequestResponse.bind(this)
    this.setEmailAddress = this.setEmailAddress.bind(this)
    this.handleUnauthenticatedRefundRequest = this.handleUnauthenticatedRefundRequest.bind(this)
  }

  setEmailAddress (event) {
    this.setState({email: event.target.value})
  }

  closeModal() {
    this.setState({
      modalVisibility: false,
      modalVoucher: null
    })
  }

  openModal(e, voucher) {
    e.preventDefault()
    this.setState({
      modalVisibility: true,
      modalVoucher: voucher
    })
  }

  makeCurrency(str) {
    const [pounds, pence] = [str.slice(0, -2), str.slice(-2)]
    return `${settings.priceFormat}${pounds}${settings.decimalNotation}${pence}`
  }

  mapProductToUrlCode(productType) {
    switch (productType.toLowerCase()) {
      case 'carpark':
        return 'cp'
      case 'hotel':
        return 'ho'
      case 'hotel_with_parking':
        return 'hcp'
      case 'insurance':
        return 'ins'
      case 'lounge':
        return 'lo'
      case 'fasttrack':
        return 'fasttrack'
      case 'transfers':
        return 'transfers'
      case 'carhire':
        return 'carhire'
      default:
        return 'cp'
    }
  }

  buildRedirectLink(voucher) {
    const { agentCode, nonFlex, productType, redemptionConditions = {} } = voucher
    const { agentGroupCode, productAuthority } = redemptionConditions
    let link = domainSettings.basePath ? [`${domainSettings.basePath}?`] : ['/?']
    if (nonFlex) {
      const productTypeCode = this.mapProductToUrlCode(productType)
      link.push(`chosen=${productTypeCode}`)
    }

    if (agentGroupCode && agentCode) link.push(`agent=${agentCode}`)
    if (productAuthority) link.push(`productAuthorityRestrictions=${productAuthority}`)

    return link.join('&')
  }

  formatDate(expiry) {
    return expiry ? dateHelper.formatDateToDddMMyy(new Date(expiry)).split(' ').slice(1).join(' ') : 'Unknown'
  }

  handleSubmit() {
    const email = this.state.email
    this.setState({ isFetchingVoucher: true })
    Helpers.emailToHash(email, (userExtId) => {
      this.lookUpVoucher(userExtId)
    })
  }

  lookUpVoucher(userExtId) {
    const voucher = this.voucherRef.current.value
    const { vouchers: { query, variables } } = getVoucherConfig

    variables.userExtId = userExtId
    variables.voucherCode = voucher

    try {
      SuperAgent
        .post(defaultAuthenticationConfig.auth.url)
        .set('Content-Type', 'application/json')
        .send(JSON.stringify({
          query,
          variables
        }))
        .withCredentials()
        .end(this.voucherLookupResponse)
    } catch (err) {
      this.setState({
        isFetchingVoucher: false,
        hasFetchedVoucher: false,
        lookUpError: true,
        lookUpErrorMessage: err,
      })
    }
  }

  voucherLookupResponse(err, res) {
    if (err || res.status === 404 || !res.body || res.body.errors) {
      this.setState({
        isFetchingVoucher: false,
        hasFetchedVoucher: false,
        lookUpError: true,
        lookUpErrorMessage: err,
      })

      return false
    }
    this.setState({
      voucherDetails: res.body.data && res.body.data.getVoucher,
      hasFetchedVoucher: true,
      isFetchingVoucher: false
    })
  }

  renderLogInButton() {
    return <button onClick={this.props.triggerLogin} className='btn btn-primary btn-lg'>{voucherTranslations.login}</button>
  }

  renderLookUpVouchers() {
    const { emailAddress, lookUp, ref, voucherLookup } = voucherTranslations
    return (
      <React.Fragment>
        <h3>{voucherLookup}</h3>
        <form className='form'>
          <div className='form-group'>
            <label htmlFor='user-voucher-email'>{emailAddress}</label>
            <input required onChange={this.setEmailAddress} id='user-voucher-email' type='email' className='form-control' />
          </div>
          <div className='form-group'>
            <label htmlFor='user-voucher-ref'>{ref}</label>
            <input required ref={this.voucherRef} id='user-voucher-ref' type='text' className='form-control' />
          </div>
          <div className='form-group'>
            {this.state.isFetchingVoucher
              ? <button type='button' className='btn btn-primary disabled'><i className='fa fa-spinner fa-spin' /></button>
              : <button type='button' className='btn btn-primary' onClick={this.handleSubmit}>{lookUp}</button>
            }
          </div>
        </form>
      </React.Fragment>
    )
  }

  renderFullVoucherRow(voucher, isActive, key, type, canRefund) {
    let voucherData = voucher
    if (!voucherData) {
      voucherData = this.state.voucherDetails
      const isActive = type === 'active'
      const hasRefund = voucherData.refunds && voucherData.refunds.length
      canRefund = isActive && !hasRefund
    }

    const { bookingRef, expires, nonFlex, remainingValue } = voucherData
    const { bookNow, headings, voucherExpired, voucherRefunded, requestRefund, waitFiveDays } = voucherTranslations

    const expiryDate = this.formatDate(expires)
    let redirectLink = isActive ? this.buildRedirectLink(voucherData) : null
    const buttonText = isActive ? bookNow : (type === 'refunded' ? voucherRefunded : voucherExpired)

    return (
      <div key={key} className={`voucher-row flex-wrap ${isActive && 'active-voucher'}`}>
        <p className='text-default m-2'><b className='text-primary'>{headings.voucher}</b><br />{bookingRef || 'N/A'}</p>
        <p className='text-default m-2'><b className='text-primary'>{headings.balance}</b><br />{this.makeCurrency(remainingValue.toString())}</p>
        <p className='text-default m-2'><b className='text-primary'>{headings.nonFlex}</b><br />{nonFlex ? 'Yes' : 'No'}</p>
        <p className='text-default m-2'><b className='text-primary'>{headings.expiry}</b><br />{expiryDate}</p>
        <div className='d-flex flex-column'>
          <div className='voucher-buttons d-flex flex-row flex-wrap mt-3 mt-md-0 ml-0 ml-md-5'>
            <a name='make-new-booking' className={`btn btn-primary mb-2 mb-md-0 ${isActive ? '' : 'disabled'}`} href={redirectLink}>{buttonText}</a>
            <br/>
          </div>
            {canRefund && <a name='request-refund' onClick={(e) => this.openModal(e, voucherData)} href='#' className='text-right'>{requestRefund}</a>}
            {type === 'refunded' && <p className='text-muted text-right'>{waitFiveDays}</p>}
        </div>
      </div>
    )
  }

  getVouchers() {
    const { loggedInData,  setVar} = this.props

    return ['active', 'refunded', 'expired'].reduce((vouchers, type) => {
      if (!loggedInData.vouchers[type] || !loggedInData.vouchers[type].length) return vouchers
      const voucherContents = loggedInData.vouchers[type].map((voucher, key) => {
        const isActive = type === 'active'
        const hasRefund = voucher.refunds && voucher.refunds.length
        const canRefund = isActive && !hasRefund
        return this.renderFullVoucherRow(voucher, isActive, key, type, canRefund)
      })

      vouchers.push([
        <div key={`voucher${type}`} className='vouchers-table flex-column pt-4'>
          {voucherContents}
        </div>
      ])
      return vouchers
    }, [])
  }

    renderVoucherRefundError() {
    return (
      <div className='alert alert-danger media' role='alert'>
        <div className='media-left media-middle'>
          <i className='fa fa-2x fa-times-circle text-danger lh-0' role='presentation' aria-hidden='true'></i>
        </div>
        <div className='media-body media-middle'>
          <strong>{voucherTranslations.errorRefund}</strong>
        </div>
      </div>
    )
  }

  renderVoucherRefundSuccess() {
    return (
      <div className='alert alert-success media' role='alert'>
        <div className='media-left media-middle'>
          <i className='fa fa-2x fa-check-circle text-success lh-0' role='presentation' aria-hidden='true'></i>
        </div>
        <div className='media-body media-middle'>
          <strong>{voucherTranslations.successRefund}</strong>
        </div>
      </div>
    )
  }

  handleUnauthenticatedRefundRequest(e, voucherRef) {
    e.preventDefault()
    Helpers.emailToHash(this.state.email, (userExtId) => {
      this.handleRefundRequest(e, voucherRef, userExtId)
    })
  }

  handleRefundRequest(e, voucherRef, userExtId) {
    e.preventDefault()

    const { voucherRefund: { query, variables } } = getVoucherConfig
    variables.voucherCode = voucherRef
    try {
      if (userExtId)  variables.userExtId = userExtId
      SuperAgent
        .post(defaultAuthenticationConfig.auth.url)
        .set('Content-Type', 'application/json')
        .send(JSON.stringify({
          query,
          variables
        }))
        .withCredentials()
        .end(this.refundRequestResponse)
    } catch (err) {
      this.setState({
        modalVisibility: false,
        modalVoucher: null,
        refundError: true,
        refundSuccess: false
      })
    }
  }

  refundRequestResponse(err, res) {
    if (err || res.status === 404 || !res.body || res.body.errors) {
      this.setState({
        modalVisibility: false,
        modalVoucher: null,
        refundError: true,
        refundSuccess: false
      })
      return false
    }

    this.setState({
      modalVisibility: false,
      modalVoucher: null,
      refundError: false,
      refundSuccess: true
    })
  }

  render() {
    const { hasFetchedVoucher, lookUpError, modalVisibility, modalVoucher, refundError, refundSuccess } = this.state
    const { id, loggedInData } = this.props
    const { vouchersFor, noVouchersFound, noVoucher, voucherBenefits, benefitOne, benefitTwo, benefitThree, successRefund, errorRefund } = voucherTranslations

    if (!loggedInData.email || !loggedInData.vouchers) {
      return(
        <div id={id}>
          {this.renderLogInButton()}
          {!hasFetchedVoucher && this.renderLookUpVouchers()}
          {refundSuccess ? <div className="alert alert-success mt-3" role="alert"><p><strong>{successRefund}</strong></p></div> : ''}
          {refundError ? <div className="alert alert-danger" role="alert"><p><strong>{errorRefund}</strong></p></div> : ''}
          {hasFetchedVoucher && !refundSuccess && this.renderFullVoucherRow(null, true, null, 'active', false)}
          {lookUpError && !hasFetchedVoucher && <p className='text-warning'>{noVoucher}</p>}
          <RefundModal
            closeModal={this.closeModal}
            handleRefundRequest={this.handleUnauthenticatedRefundRequest}
            isVisible={modalVisibility}
            voucher={modalVoucher}
          />
        </div>
      )
    }

    const vouchers = this.getVouchers()

    return (
      <div id={id} className='vouchersContainer'>
        {refundError && this.renderVoucherRefundError()}
        {refundSuccess && this.renderVoucherRefundSuccess()}

        <RefundModal
          closeModal={this.closeModal}
          handleRefundRequest={this.handleRefundRequest}
          isVisible={modalVisibility}
          voucher={modalVoucher}
        />

        <h2>{vouchersFor} {loggedInData.title} {loggedInData.first_name} {loggedInData.last_name}</h2>
        <div className="alert alert-info mt-4 mb-2">
        <p className="pb-2"><i className="fa fa-info-circle"></i> {voucherBenefits}</p>
          <ul>
            <li>{benefitOne}</li>
            <li>{benefitTwo}</li>
            <li>{benefitThree}</li>
          </ul>
        </div>
        {vouchers.length ? vouchers : <p className='alert alert-warning'>{noVouchersFound}</p>}
      </div>
    )
  }
}

export default ReduxStores(Vouchers, ['login'])



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/vouchers.jsx